import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Route, Routes } from 'react-router-dom'; // Changed to HashRouter
import './index.css';
import reportWebVitals from './reportWebVitals';
import LandingPage from './landing_page';
import CursorRunner from './components/CursorRunner';
import csvFile from './assets/coords/locations.csv';

// Heavy routes (maplibre / three.js) are split out so the landing page stays lean.
const MapCard = lazy(() => import('./MapCard'));
const ThirtyFiveMM = lazy(() => import('./35mm'));
const Experience = lazy(() => import('./Experience'));

const RouteFallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-cream font-mono text-sm uppercase tracking-[0.3em] text-ink">
    Loading…
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <CursorRunner />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/map" element={<MapCard csvFile={csvFile} />} />
          <Route path="/ThirtyFiveMM" element={<ThirtyFiveMM />} />
          <Route path="/experience" element={<Experience />} />
        </Routes>
      </Suspense>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
